export const sortState = {
  sortType: null,
  sortDirection: null,
};

export const sortActions = {
  setSort({ commit, dispatch }, { sortType, sortDirection }) {
    commit('setSort', { sortType, sortDirection });
    dispatch('fetchItems');
  },
};

export const sortMutations = {
  setSort(state, { sortType, sortDirection }) {
    if (sortType && sortDirection) {
      state.sortType = sortType;
      state.sortDirection = sortDirection;
    } else {
      state.sortType = null;
      state.sortDirection = null;
    }
  },
};

export const sortGetters = {

};
